import {Component, ViewContainerRef, OnInit} from '@angular/core';
import { JsonApiService} from "./core/api/json-api.service";

declare var $: any;

@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit  {
  public title = 'app works!';

  public constructor(
      private viewContainerRef: ViewContainerRef,
      private jsonApiService: JsonApiService) {

  	  sessionStorage.setItem('sm-fixed-header','true');
  	  sessionStorage.setItem("defaultLocale", "es");
      Promise.all([this.obtenerI18n()]);


      Promise.all([
          System.import('script-loader!smartadmin-plugins/datatables/datatables.min.js'),
      ]).then(()=>{
          $.fn.dataTable.ext.errMode = 'none';
      });

      $.get('assets/plugins/gritter/js/jquery.gritter.js',undefined, null, "script" ).done(function() {

      });
  }

  ngOnInit() {
     
  }  

    private obtenerI18n() {
        let i18n = sessionStorage.getItem("defaultLocale");
        //
        let url = "";
        if (i18n === "es") {
            url = '/langs/es.json';
        }
        else {
            url = '/langs/us.json';
        }
        this.jsonApiService.fetchAjaxSincronoSessionStorage(url,"datai18n");
    }
  
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts